<template>
  <div class="protocal-link">
    <a class="link" href="javascript:;" @click="openServiceLink">{{
      letter.fwtk
    }}</a>
    <span class="line">|</span>
    <a class="link" href="javascript:;" @click="openPrivacyLink">{{
      letter.yszc
    }}</a>
  </div>
</template>

<script>
import serviceLink from '@mixins/officialWebStore/serviceLink';
export default {
  name: 'ProtocolLink',
  mixins: [serviceLink],
  computed: {
    letter() {
      return this.$store.state.letter;
    }
  }
};
</script>

<style scoped lang="scss">
.protocal-link {
  display: flex;
  justify-content: center;
  color: #333;
  font-size: 20px;
  margin: 30px auto;
  .link {
    color: #333;
    cursor: pointer;
  }
  .line {
    margin: 0 20px;
  }
}
</style>
